// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"494": "4077578422d4","5545": "20927b2f494d","8795": "631c6af3ebb8",}[chunkId] + ".css"
}